import React from 'react';

const Card = ({
    loading, bgColor, title,
    leftUpperTitle, leftUpperValue, leftLowerTitle, leftLowerValue, leftColor,
    centerUpperTitle, centerUpperValue, centerLowerTitle, centerLowerValue, centerColor,
    rightUpperTitle, rightUpperValue, rightLowerTitle, rightLowerValue, rightColor,
    counterTitle, counterValue, counterColor, subtitleCounter, divider,
    topUpperTitle, topUpperValue
}) => (
    <div className="card border-0">
        <div className={`card-header ${bgColor}`}>
            <div className="row">
                <div className="col">
                    <h5 className="h3 mb-0 text-white">{title}</h5>
                </div>
                <div className="col">
                    <div className="badge badge-info pull-right">{subtitleCounter}</div>
                </div>
            </div>
        </div>
        <div className="card-body text-center">
            <div className="row">
                <div className="col">
                    <span className="h6 surtitle ">{topUpperTitle}</span>
                    <span className={`d-block h4 ${leftColor}`}>{topUpperValue}</span>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <span className="h6 surtitle ">{leftUpperTitle}</span>
                    <span className={`d-block h4 ${leftColor}`}>{leftUpperValue}</span>
                </div>
                {centerUpperTitle &&
                    <div className="col">
                        <span className="h6 surtitle">{centerUpperTitle}</span>
                        <span className={`d-block h4 ${centerColor}`}>{centerUpperValue}</span>
                    </div>
                }
                {rightUpperTitle &&
                    <div className="col">
                        <span className="h6 surtitle">{rightUpperTitle}</span>
                        <span className={`d-block h4 ${rightColor}`}>{rightUpperValue}</span>
                    </div>
                }
            </div>
        </div>
    </div>
);

export default Card;



// WEBPACK FOOTER //
// ./src/components/Pages/Items/Header/Card.js